export default __webpack_public_path__ + "logo.9da16355fee6720513f251eee54301ac.png";